import axios from 'axios';
import Turbolinks from 'turbolinks';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['notification'];

  updateIcon(event) {
    const icon = document.getElementById(event.params.icon);
    if (icon) {
      icon.classList.toggle('bi-chevron-right');
      icon.classList.toggle('bi-chevron-down');
    }
  }

  async updateMetStatus(event) {
    const url = window.location.href;
    const metGoalForm = document.getElementById(event.params.metGoalId);
    
    if (!metGoalForm) return;
    
    const { goalId, metUrl, goalClass } = event.params;
    const formData = new FormData(metGoalForm);
    const goalData = Object.fromEntries(formData);

    if (goalClass === 'LongTermGoal')
      await axios
        .patch(`${metUrl}`, {
          long_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    else if (goalClass === 'ShortTermGoal') {
      await axios
        .patch(`${metUrl}`, {
          short_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    }
  }

  async upgradeGoal(event) {
    const url = window.location.href;
    const upgradeGoalForm = document.getElementById(event.params.upgradeGoalId);
    if (!upgradeGoalForm) return;

    const { upgradeUrl, goalClass } = event.params;
    const formData = new FormData(upgradeGoalForm);
    const goalData = Object.fromEntries(formData);

    if (goalClass === 'LongTermGoal')
      await axios
        .patch(`${upgradeUrl}`, {
          long_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    else if (goalClass === 'ShortTermGoal') {
      await axios
        .patch(`${upgradeUrl}`, {
          short_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    }
  }

  async downgradeGoal(event) {
    const url = window.location.href;
    const downgradeGoalForm = document.getElementById(event.params.downgradeGoalId);
    if (!downgradeGoalForm) return;

    const { downgradeUrl, goalClass } = event.params;
    const formData = new FormData(downgradeGoalForm);
    const goalData = Object.fromEntries(formData);

    if (goalClass === 'LongTermGoal')
      await axios
        .patch(`${downgradeUrl}`, {
          long_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    else if (goalClass === 'ShortTermGoal') {
      await axios
        .patch(`${downgradeUrl}`, {
          short_term_goal: goalData,
        })
        .then(async (response) => {
          await Turbolinks.visit(`${url}`);
        })
        .catch((err) => {
          this.notifier(err);
        });
    }
  }

  notifier(message) {
    this.notificationTarget.classList.remove('d-none');
    this.notificationTarget.textContent = message;
    setTimeout(() => {
      this.notificationTarget.classList.add('d-none');
      this.notificationTarget.textContent = '';
    }, 10000);
  }
}
